
import React from "react";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";

const ButtonMailto = ({ mailto, label }) => {
    return (
        <Link
            to='#'
            onClick={(e) => {
                window.location.href = mailto;
                e.preventDefault();
            }}
            className='text-policy'
        >
            {label}
        </Link>
    );
};

ButtonMailto.propTypes = {
    mailto: PropTypes.string,
    label: PropTypes.string,
};

export default ButtonMailto;